import Api from './Api'
import moment from 'moment'

export default {
  getObjects (data, csv) {
    if (csv) {
      return Api().post('/objekt/getnetauctionobjects.json', csv, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    }

    return Api().post('/objekt/getnetauctionobjects.json', data)
  },

  removeObject: function (objektId) {
    return Api().delete('/nettauksjon/nettobjekt/' + objektId + '.json')
  },

  moveObject: function (data) {
    return Api().post('/nettauksjon/nettobjekt/move-auction.json', data)
  },

  getAuctionList (avdeling, status = 'pending', page = 1) {
    // Classic: 0; Online: 1; Wine: 2
    let avdelingsid

    switch (avdeling) {
      case 'vin':
        avdelingsid = 2
        break
      case 'nett':
        avdelingsid = 1
        break
      default:
        avdelingsid = 0
    }
    return Api().get('/nettauksjon.json', {params: {avdelingsId: avdelingsid, status: status, page: page}})
  },

  getAuction (id, withObjects = true, page = 1) {
    return Api().get('/nettauksjon/' + id + '.json', {params: {withObjects: withObjects, page: page}})
  },

  save (id, data) {
    if (!id) {
      return Api().post('/nettauksjon.json', data)
    }

    return Api().put('/nettauksjon/' + id + '.json', data)
  },

  getElasticSearchObjects (start, parameters) {
    let sort = {
      sort: parameters.sort_by,
      direction: 'DESC'
    }
    let betweenDate = {
      field: 'Start',
      start: moment(start).format('YYYY-MM-DD 00:00:00'),
      finish: moment(start).add(1, 'd').format('YYYY-MM-DD 00:00:00')
    }
    return Api().post('/objekt/search.json?limit=' + parameters.limit, {betweenDate: betweenDate, _sort: sort, hide_ready_for_auction: parameters.viewed})
  },

  csvAddObject (data) {
    return Api().post('objekt/csv/addObject.json', data)
  },

  csvRemoveObject (data) {
    return Api().post('objekt/csv/removeObject.json', data)
  },

  csvChangeOrder (data) {
    return Api().post('objekt/csv/changeOrder.json', data)
  }
}



// WEBPACK FOOTER //
// ./src/services/NettAuksjonService.js